import { type Conversation } from "shared/apiClient";
import { AssessmentLights } from "shared/types";
import { getText } from "shared/lib";

import { useCouncilLocalisation } from "shared/hooks";

import { ExternalLinkIcon } from "shared/components";

export interface CARProps {
  assessmentLights: string;
  conversation: Conversation | undefined | null;
}

export function CAR({ assessmentLights, conversation }: CARProps) {
  const { getLocalisationEntry } = useCouncilLocalisation(conversation);

  const landataLink = getLocalisationEntry("councilApplyForCertificateOfTitleLink");
  const buildingPermitLink =
    "https://www.cardinia.vic.gov.au/info/20051/building/370/do_i_need_a_building_permit";
  const planningDocumentsLink =
    "https://www.cardinia.vic.gov.au/info/93/planning/432/request_planning_documents_advice_or_information_in_writing";
  const businessPermitChecklistLink =
    "https://creating.cardinia.vic.gov.au/cardinia-business/business-permits-and-registrations";
  const planningPermitsLink =
    "https://www.cardinia.vic.gov.au/info/93/planning/409/planning_permits";

  const renderRequestCertificateOfTitle = () => {
    return (
      <div className="mb-8">
        <h3 className="text-headingmd">
          {getText("Request a Certificate of Title")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "This tool doesn't account for covenants (restrictions), agreements, caveats, and easements which can impact what you can and can't do on a property. A Certificate of Title can include this information and can be obtained online.",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href={landataLink}
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Landata")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  const renderCheckBuildingPermitRequirement = () => {
    return (
      <div className="mb-8">
        <h3 className="text-headingmd">
          {getText("Check if you need a building permit")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "This tool dosen't account for works requiring authorisation under the Building Regulations 2018. Please visist Council's website 'do i need a building permit' for further information on the types of work that need building permits. Please note Council does not issue builidng permits, this is arranged with private builidng surveyors",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href={buildingPermitLink}
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Do i need a building permit?")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  const renderApplyForInformationOnPlanningControls = () => {
    return (
      <div className="mb-8">
        <h3 className="text-headingmd">
          {getText("Apply for Information on Planning Controls")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "If you need formal written advice for your builder or surveyor that a planning permit is not required, please lodged an application for information on planning controls through out ePlanning Portal. Please note you will need to log in or create an account on the portal to utilise the service.",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href={planningDocumentsLink}
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Community Portal")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  const renderContactBusinessConciergeService = () => {
    return (
      <div className="mb-8">
        <h3 className="text-headingmd">
          {getText("Contact the Business Concierge Service")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "Are you setting up a home-based or small business? Your may need apporvals from other areas of Council to operate the business. Please visit Council's Business Permit Checklist for more information.",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href={businessPermitChecklistLink}
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Business Permit Checklist")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  const renderRefineYourProposal = () => {
    return (
      <div className="mb-8">
        <h3 className="text-headingmd">{getText("Refine your proposal")}</h3>
        <p className="text-bodymd mb-2">
          {getText(
            "Check your myLot report for the unanswered questions that will finalise the results of your advice.",
          )}
        </p>
      </div>
    );
  };

  const renderSeekPreApplicationAdvice = () => {
    return (
      <div className="mb-8">
        <h3 className="text-headingmd">
          {getText("Seek pre-application advice")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "For more substantial proposals to understand the constraints and considerations and if the application warrants Council's support, it is strongly encouraged to lodge an application for Pre-application Advice. This allows you to arrnage meetings and recieve written advice from Council. Please note application documents are required and don't forget to quote your enquiry ID from MyLot",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href={planningDocumentsLink}
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Community Portal")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  const renderApplyForInformationOnPlanningControls3 = () => {
    return (
      <div className="mb-8">
        <h3 className="text-headingmd">
          {getText("Apply for information on planning controls")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "If you need formal written advice for your builder or surveyor that a planning permit is not required, please lodged an application for information on planning controls through out ePlanning Portal. Please note you will need to log in or create an account on the portal to utilise the service.",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href={planningDocumentsLink}
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Community Portal")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  const renderLearnHowToApply = () => {
    return (
      <div className="mb-8">
        <h3 className="text-headingmd">{getText("Learn how to apply")}</h3>
        <p className="text-bodymd mb-2">
          {getText(
            "Like more information on the planning permit applications and how to apply? Have a look at Council's website which provides a number of handy rescouces and explanation on the process.",
          )}
        </p>
        <a
          className="text-textLink hover:text-textLinkHover text-bodymd inline-flex cursor-pointer underline"
          href={planningPermitsLink}
          rel="noreferrer"
          tabIndex={0}
          target="_blank"
        >
          {getText("Learn how to apply")}
          <ExternalLinkIcon className="ml-2 mt-[3px]" />
        </a>
      </div>
    );
  };

  const renderDiscussWithPlanners = () => {
    return (
      <div className="mb-8">
        <h3 className="text-headingmd">
          {getText("Discuss your proposal with a planner")}
        </h3>
        <p className="text-bodymd mb-2">
          {getText(
            "Have questions? Contact us to speak to one of our planners. When you contact us, please tell us your report ID:",
          )}
        </p>
        <div className="border-interactiveBorder bg-interfaceWhite text-textPrimary text-bodylg w-min text-nowrap rounded border px-2 py-1.5 font-medium">
          {conversation?.identifier?.toUpperCase() || ""}
        </div>
      </div>
    );
  };

  switch (assessmentLights) {
    case AssessmentLights.NoPermitRequired:
      return (
        <>
          {renderRequestCertificateOfTitle()}
          {renderCheckBuildingPermitRequirement()}
          {renderApplyForInformationOnPlanningControls()}
          {renderContactBusinessConciergeService()}
          {renderDiscussWithPlanners()}
        </>
      );
    case AssessmentLights.MoreInformationRequired:
      return (
        <>
          {renderRefineYourProposal()}
          {renderSeekPreApplicationAdvice()}
          {renderRequestCertificateOfTitle()}
          {renderDiscussWithPlanners()}
        </>
      );
    case AssessmentLights.RequiresPermit:
      return (
        <>
          {renderRequestCertificateOfTitle()}
          {renderApplyForInformationOnPlanningControls3()}
          {renderSeekPreApplicationAdvice()}
          {renderLearnHowToApply()}
          {renderDiscussWithPlanners()}
        </>
      );
    case AssessmentLights.Prohibited:
      return <>{renderDiscussWithPlanners()}</>;
  }
}
